import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Timesheets';

export const timesheetEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByEmployeeWeek: (employeeId: string, weekStartDate: string) =>
    buildEndpoint(`${BASE_PATH}/employee/${employeeId}/week/${weekStartDate}`),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  reopen: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/reopen`, { id }),
  basePath: () => BASE_PATH,
} as const;

export default timesheetEndpoints;
